import { render, staticRenderFns } from "./apkontrak.vue?vue&type=template&id=7897c194"
import script from "./apkontrak.vue?vue&type=script&lang=js"
export * from "./apkontrak.vue?vue&type=script&lang=js"
import style0 from "./apkontrak.vue?vue&type=style&index=0&id=7897c194&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports